import { query, queryAll } from "./dom";
import { createStorage } from "./storage";

const elements = {
  viewPicker: () => query("#page-ohjelma #program-view-picker"),
  viewButtons: () => queryAll("#program-view-picker button"),
  hideAfterDate: () => queryAll("#page-ohjelma [data-hide-after-date]"),
  showPastProgram: () => query("#page-ohjelma [name='show-past-programs']"),
};

const programTabStorage = createStorage("programTab");

let selectedButton = "";

const setTabStates = () => {
  elements.viewButtons().forEach((button) => {
    const isSelected = button.id === selectedButton;
    button.setAttribute("aria-selected", String(isSelected));
    button.classList.toggle("bg-blue-500", isSelected);
    button.classList.toggle("text-white", isSelected);
    button.classList.toggle("border-0", isSelected);
    button.classList.toggle("bg-transparent", !isSelected);

    const targetTabId = button.getAttribute("aria-controls");
    const targetTab = document.getElementById(targetTabId);
    if (isSelected) {
      targetTab.removeAttribute("hidden");
      targetTab.style.display = null;
    } else {
      targetTab.setAttribute("hidden", "");
      targetTab.style.display = "none";
    }
    targetTab.classList.remove("hidden", "xl:block", "xl:hidden");
  });
};

const handleViewButtonClick = (event) => {
  selectedButton = event.target.id;
  programTabStorage.set(selectedButton);
  setTabStates();
};

const setupProgramViewButtons = () => {
  const viewPicker = elements.viewPicker();
  if (!viewPicker) return;

  const isLargeViewport = window.innerWidth >= 1024;
  selectedButton =
    programTabStorage.get() || (isLargeViewport ? "view-table" : "view-list");

  elements.viewButtons().forEach((button) => {
    button.addEventListener("click", handleViewButtonClick);
  });
  setTabStates();
};

const togglePastPrograms = () => {
  const showPastProgramsElem = elements.showPastProgram();
  const hideAfterDateElems = elements.hideAfterDate();
  const now = new Date();
  const lastProgramElem = hideAfterDateElems.at(-1);
  const lastProgramDate = new Date(lastProgramElem.dataset.hideAfterDate);
  const allProgramsArePast = lastProgramDate < now;
  if (allProgramsArePast) {
    showPastProgramsElem.parentElement.classList.add("hidden");
    return;
  }
  for (const element of hideAfterDateElems) {
    const date = new Date(element.dataset.hideAfterDate);
    if (date < now) {
      element.classList.toggle("hidden", !showPastProgramsElem.checked);
    }
  }
};

const setupPastProgramHide = () => {
  const hideAfterDate = elements.hideAfterDate();
  const showPastProgram = elements.showPastProgram();
  if (!hideAfterDate.length || !showPastProgram) return;

  const showPastPrograms = showPastProgram.checked;
  togglePastPrograms(showPastPrograms);

  showPastProgram.addEventListener("click", (event) => {
    togglePastPrograms(event.target.checked);
  });
};

export const setup = () => {
  setupProgramViewButtons();
  setupPastProgramHide();
};
